import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef, OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {UntypedFormBuilder} from '@angular/forms';
import {DataService} from '../../../../Services/data.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {StorageService} from '../../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {CustomFilterPipe} from '../../../common/custom-filter.pipe';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';
import {EmailService} from '../../../../Services/email.service';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {PermissionsService} from '../../../../Services/permissions.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {RoutingTrackerService} from '../../../../Services/routing-tracker.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {IsFilterOnService} from '../../../../Services/is-filter-on.service';
import {firstValueFrom, Subject, takeUntil} from 'rxjs';
import {ReportPrintService} from '../../../../Services/report-print.service';


@Component({
  selector: 'app-transaction-detail',
  templateUrl: './transaction-detail.component.html',
  styleUrls: ['./transaction-detail.component.css'],
  standalone: false
})
export class TransactionDetailComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  reportToAttachToEmail = '';
  timeOut = 0;
  public urlParams: any = [];
  public vm: any = {
    toDateSelect: [],
    fromDateSelect: [],
    DataFormat: 'MM/dd/yyyy',
    dateError: false,
    report: [],
    request: {
      toDate: null,
      fromDate: null,
      location_group_id: null,
      columns: '',
      company_id: null,
      rf_id_1: null,
      rf_id_2: null,
      rf_id_3: null,
      rf_id_4: null,
      rf_id_5: null,
      margin_id: null,
      location_id: null,
      accountInput: null,
      accountParentId: null,
      accountSubtotalId: null,
      accountTypeId: null,
      dataType: null,
      account_id: null,
      account_parent_id: null,
      account_subtotal_id: null,
      account_type_id: null,
      bank_id: null,
      entity_id: null,
      entity_city: null,
      entity_state: null,
      entity_type_id: null,
      item_id: null,
      payment_type_id: null,
      currency_id: null,
      includeUnposted: null,
    },
    showSpecificDates: false,
    buttonsDisabled: false,
    d: {
      date: '',
      name: '',
    },
    exportToExcel: true,
    columns: false,
    company: [],
    locationGroup: [],
    location: [],
    currency: [],
    location_group: [],
    rfType: [],
    rf1: [],
    rf2: [],
    rf3: [],
    rf4: [],
    rf5: [],
    margin: [],
    filtered: false,
    showFilters: false,
    toDateError: false,
    totalDebits: 0,
    totalCredits: 0,
    monthCount: 0,
    liabEquityCurrent: 0,
    liabEquityPrior: 0,
    totalCurrentAssets: 0,
    totalPriorAssets: 0,
    companyData: null,
    locationData: null,
    calculatedTime: new Date(),
    priorToDate: 0,
    ToEmailError: null,
    showEmail: true,
    ToEmail: null,
    emailed: null,
    email: {
      toemail: null,
      fromemail: this.appConfigService.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    Preferences: null,
    permissions: null,
    currentMonthMargin: 0,
    priorMonthMargin: 0,
    currentPeriodMargin: 0,
    priorPeriodMargin: 0,
    account: [],
    fromDateError: null,
    netIncomeCurrent: null,
    netIncomePrior: null,
    calculatedDate: null,
    toDateTitle: null,
    fromDateTitle: null,
    priorToDateTitle: null,
    priorToDateLink: null,
    priorMonthFromDateLink: null,
    currentMonthFromDateLink: null,
    priorFromDateLink: null,
    priorFromDateTitle: null,
    accountParents: [],
    accountSubtotal: [],
    bank: [],
    entity: [],
    entityAddress: [],
    entityType: [],
    paymentType: [],
    inventoryItem: [],
    accountType: [],
    inventoryItemName: [],
    entityState: [],
    entityCity: [],
    accountName: [],
    accountInput: null,
    accountId: null,
    bankId: null,
    companyId: null,
    currencyId: null,
    entityId: null,
    entityTypeId: null,
    locationId: null,
    locationGroupId: null,
    paymentTypeId: null,
    rfId1: null,
    rfId2: null,
    rfId3: null,
    rfId4: null,
    rfId5: null,
    marginId: null,
    accountTypeName: null,
    accountParentName: null,
    accountSubtotalName: null,
    dataType: null,
    bankName: null,
    companyName: null,
    locationName: null,
    locationGroupName: null,
    paymentTypeName: null,
    rf1Name: null,
    rf2Name: null,
    rf3Name: null,
    rf4Name: null,
    rf5Name: null,
    startAccount: null,
    entityInput: null,
    inventoryItemInput: '',
    entityName: [],
    entityTypeName: null,
    entityCityName: null,
    entityStateName: null,
    accountFilter: [],
    entityFilter: {name: ''},
    inventoryItemFilter: {search_string: ''},
    user: [],
    startInventoryItem: 0,
    startEntity: 0,
    paymentFilter: {search_string: ''},
  };

  buttonConfig: any = {
    reportFormat: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };
  reportDataToSendInEmail: EmailModel = new EmailModel();


  rptName: string;

  isLoading = true;

  noDataFound = false;
  routedFrom = '';

  // Flat row array for virtual scrolling
  flatRows: Array<{ rowType: 'account-header' | 'transaction' | 'account-footer' | 'separator'; account?: any; transaction?: any }> = [];

  buildFlatRows(): void {
    const rows: typeof this.flatRows = [];
    for (const a of (this.vm.report || [])) {
      rows.push({rowType: 'account-header', account: a});
      if (!this.vm.hideDetails) {
        for (const t of (a.transactions || [])) {
          if (t.debit_credit !== 0) {
            rows.push({rowType: 'transaction', account: a, transaction: t});
          }
        }
      }
      rows.push({rowType: 'account-footer', account: a});
      rows.push({rowType: 'separator'});
    }
    this.flatRows = rows;
  }

  private unsubscribeDestroy$: Subject<void> = new Subject<void>();

  constructor(
    public localStorage: StorageService,
    public tableDataService: DataService,
    private titleService: Title,
    public appConfigService: AppConfigService,
    public route: ActivatedRoute,
    public router: Router,
    public aEmail: EmailService,
    private fb: UntypedFormBuilder,
    public dateFilter: DateFilterService,
    public notification: BsToastService,
    private cd: ChangeDetectorRef,
    public cFilter: CustomFilterPipe,
    public datePipe: DatePipe,
    public permissions: PermissionsService,
    public prevUrl: RoutingTrackerService,
    public isFiltered: IsFilterOnService,
    private reportPrint: ReportPrintService
  ) {

    this.vm.Preferences = JSON.parse(this.localStorage.StorageGet('Preferences'));
    this.vm.permissions = JSON.parse(this.localStorage.StorageGet('Permissions'));

    const prevUrl2 = this.prevUrl.getPreviousUrl();

    if (prevUrl2 !== null && prevUrl2 !== undefined && prevUrl2 !== '') {
      this.routedFrom = prevUrl2;
    } else {
      this.routedFrom = '';
    }
  }

  ngOnInit() {
    this.urlParams = this.route.snapshot.queryParams;

    // Robustly decode and normalize incoming fromDate/toDate query params
    this.applyQueryParamDates();

    if (!this.vm.request.toDate && !this.vm.request.fromDate) {
      this.newDateFilter(new Date(), new Date());
      const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
      this.vm.request.toDate = range.toDate;
      this.vm.request.fromDate = range.fromDate;
    }

    this.reportToAttachToEmail = $localize`:AcctX Transaction Details Report @@acctXTransactionDetailsReport:AcctX Transaction Details Report`;

    // If only a To date exists, optionally derive a From date as the first day of the same month
    if (this.vm.request.toDate && !this.vm.request.fromDate) {
      const date = new Date(this.vm.request.toDate);
      if (!isNaN(date.getTime())) {
        const fromdate = new Date(date.getFullYear(), date.getMonth(), 1);
        // Store as yyyy-MM-dd for consistency
        this.vm.request.fromDate = this.dateFilter.GetDateFormat(fromdate);
      }
    }

    this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

    this.rptName = $localize`:Transaction Details Report @@transactionDetailsReport:Transaction Details Report`;

    this.FilterOptionsInit().then();
  }

  toggleHideDetails(): void {
    this.vm.hideDetails = !this.vm.hideDetails;
    this.buildFlatRows();
  }

  exportToExcel() {
    if (!this.vm.report?.length) {
      this.notification.showWarningToast('No data to export.');
      return;
    }
    const rows: any[] = [];
    for (const a of this.vm.report) {
      rows.push({
        Account: a.account,
        Type: 'Opening Balance',
        Date: '',
        Reference: '',
        Description: '',
        Debits: a.openingBalance > 0 ? a.openingBalance : '',
        Credits: a.openingBalance < 0 ? (0 - a.openingBalance) : '',
        Balance: ''
      });
      for (const t of (a.transactions || [])) {
        if (t.debit_credit === 0) {
          continue;
        }
        let ref = '';
        if (t.batch_type_id == '2' || t.batch_type_id == '4') {
          ref = 'Invoice: ' + (t.number || '');
        } else if (t.batch_type_id == '3' || t.batch_type_id == '5') {
          ref = 'Payment: ' + (t.number || t.audit_sequence || '');
        } else if (t.batch_type_id == '1') {
          ref = 'Entry: ' + (t.number || '');
        }
        const desc = [t.entity_name, t.location_name, t.bank_name, t.payment_type_name, t.description]
          .filter(Boolean).join(' | ');
        rows.push({
          Account: '',
          Type: '',
          Date: t.header_date ? new Date(t.header_date).toLocaleDateString() : '',
          Reference: ref,
          Description: desc,
          Debits: t.debit_credit > 0 ? t.debit_credit : '',
          Credits: t.debit_credit < 0 ? (0 - t.debit_credit) : '',
          Balance: t.balance ?? ''
        });
      }
      rows.push({
        Account: a.account,
        Type: 'Ending Balance',
        Date: '',
        Reference: '',
        Description: '',
        Debits: a.endingBalance > 0 ? a.endingBalance : '',
        Credits: a.endingBalance < 0 ? (0 - a.endingBalance) : '',
        Balance: ''
      });
      rows.push({Account: '', Type: '', Date: '', Reference: '', Description: '', Debits: '', Credits: '', Balance: ''});
    }
    const currentDate = new Date().toDateString();
    import('xlsx').then(xlsx => {
      const ws = xlsx.utils.json_to_sheet(rows);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, 'TransDetail');
      xlsx.writeFile(wb, 'TransDetailReport' + currentDate + '.xlsx');
      this.notification.showSuccessToast('Exported to download directory as: TransDetailReport' + currentDate + '.xlsx', 'Success');
    });
  }

  ngAfterViewInit() {
    this.titleService.setTitle(this.rptName);

    this.cd.detectChanges();
    // this.EmailContent.forEach((div: ElementRef) => console.log(div.nativeElement));
  }

  ngAfterViewChecked() {
  }

  setEmailData() {
    // prepare email object
    this.getReportData();

    // Show the shared Send Email modal directly
    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  getReportData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Transaction Detail Report';

    // printing options
    emailDocObj.print_orientation = '1';
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '';
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // capture html after change detection
    try {
      this.cd.detectChanges();
    } catch {
    }
    // Use the same HTML as printing to ensure consistency
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml();
    } catch {
      emailDocObj.pdfHtml = '';
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Transaction_Detail_Report_' + yyyy + mm + dd + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;
  }

  // Print the report content using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Transaction Detail print failed', e);
    }
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(): string {
    const content = this.buildExportHtml();
    const meta = [];
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    if (from || to) {
      meta.push({label: 'Period', value: `${from} to ${to}`});
    }
    return this.reportPrint.buildHtml({title: 'Transaction Detail', contentHtml: content, meta, orientation: 'landscape'});
  }

  // Build export/email table HTML from vm.report data — no DOM dependency
  private buildExportHtml(): string {
    const fmt = (n: number) => n.toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2});
    const fmtDate = (d: any) => d ? new Date(d).toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'}) : '';
    const td = (content: string, style = '') => `<td style="border-bottom:1px solid #aaa;${style}">${content}</td>`;
    const tdR = (content: string) => td(content, 'text-align:right;');

    let rows = '';
    for (const a of (this.vm.report || [])) {
      // Account header row
      rows += `<tr style="font-weight:bold">
        <td style="border-bottom:2px solid #aaa">&nbsp;</td>
        <td style="border-bottom:2px solid #aaa">${a.account || ''}</td>
        <td style="border-bottom:2px solid #aaa">&nbsp;</td>
        <td style="text-align:right;border-bottom:2px solid #aaa">${a.openingBalance > 0 ? fmt(a.openingBalance) : ''}</td>
        <td style="text-align:right;border-bottom:2px solid #aaa">${a.openingBalance < 0 ? fmt(0 - a.openingBalance) : ''}</td>
        <td style="border-bottom:2px solid #aaa">&nbsp;</td>
      </tr>`;

      // Transaction rows
      for (const t of (a.transactions || [])) {
        if (t.debit_credit === 0) {
          continue;
        }
        let ref = '';
        if (t.batch_type_id == '2' || t.batch_type_id == '4') {
          ref = `Invoice: <em>${t.number || ''}</em>`;
        } else if (t.batch_type_id == '3' || t.batch_type_id == '5') {
          ref = `Payment: <em>${t.number || t.audit_sequence || ''}</em>`;
        } else if (t.batch_type_id == '1') {
          ref = `Entry: <em>${t.number || ''}</em>`;
        }

        const descParts: string[] = [];
        if (t.entity_name) {
          descParts.push(`<strong>${t.entity_name}</strong>`);
        }
        if (t.location_name) {
          descParts.push(`<small style="color:#888">loc</small>: ${t.location_name}`);
        }
        if (t.bank_name) {
          descParts.push(`<small style="color:#888">bank</small>: ${t.bank_name}`);
        }
        if (t.payment_type_name) {
          descParts.push(`<small style="color:#888">pmt-type:</small> ${t.payment_type_name}`);
        }
        if (t.rf1_name) {
          descParts.push(t.rf1_name);
        }
        if (t.rf2_name) {
          descParts.push(t.rf2_name);
        }
        if (t.rf3_name) {
          descParts.push(t.rf3_name);
        }
        if (t.rf4_name) {
          descParts.push(t.rf4_name);
        }
        if (t.rf5_name) {
          descParts.push(t.rf5_name);
        }
        if (t.description && t.description.trim()) {
          descParts.push(`<small style="color:#888">desc:</small> ${t.description}`);
        }

        let balance = '';
        if (a.debit == '1') {
          balance = t.balance > 0 ? fmt(t.balance) : (t.balance < 0 ? `(${fmt(0 - t.balance)})` : '');
        } else {
          balance = t.balance < 0 ? fmt(0 - t.balance) : (t.balance > 0 ? `(${fmt(t.balance)})` : '');
        }

        rows += `<tr>
          ${td(ref)}
          ${td(descParts.join(' &nbsp; '))}
          ${td(`<small>${fmtDate(t.header_date)}</small>`, 'white-space:nowrap;width:1px;')}
          ${tdR(t.debit_credit > 0 ? fmt(t.debit_credit) : '')}
          ${tdR(t.debit_credit < 0 ? fmt(0 - t.debit_credit) : '')}
          ${tdR(balance)}
        </tr>`;
      }

      // Ending balance row
      rows += `<tr style="font-weight:bold">
        <td style="border-top:1px solid #aaa">&nbsp;</td>
        <td style="border-top:1px solid #aaa">${a.account || ''}</td>
        <td style="border-top:1px solid #aaa">&nbsp;</td>
        <td style="text-align:right;border-top:1px solid #aaa">${a.endingBalance > 0 ? fmt(a.endingBalance) : ''}</td>
        <td style="text-align:right;border-top:1px solid #aaa">${a.endingBalance < 0 ? fmt(0 - a.endingBalance) : ''}</td>
        <td style="border-top:1px solid #aaa">&nbsp;</td>
      </tr>
      <tr>
        <td style="background-color:#ccc" colspan="6"></td>
      </tr>`;
    }

    return `<table style="width:100%;font-size:10px" cellspacing="0" cellpadding="4">
      <thead><tr>
        <th style="border-bottom:3px solid #888">&nbsp;</th>
        <th style="border-bottom:3px solid #888">&nbsp;</th>
        <th style="border-bottom:3px solid #888">&nbsp;</th>
        <th style="text-align:center;width:10%;border-bottom:3px solid #888">Debits</th>
        <th style="text-align:center;width:10%;border-bottom:3px solid #888">Credits</th>
        <th style="text-align:center;width:10%;border-bottom:3px solid #888">Balance</th>
      </tr></thead>
      <tbody>${rows}</tbody>
    </table>`;
  }

  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  // Decode and normalize from/to dates from query params
  private applyQueryParamDates(): void {
    const qp = this.urlParams || {};
    // Parse to Date objects for correct datepicker/display behavior
    const normalizeToDate = (v: any): Date | null => {
      if (v === null || v === undefined || v === '') {
        return null;
      }
      if (v instanceof Date) {
        return v;
      }
      let s = String(v);
      try {
        s = decodeURIComponent(s);
      } catch {
      }
      // Direct parse (supports ISO like 2020-08-02T00:00:00 and yyyy-MM-dd)
      let d = new Date(s);
      if (!isNaN(d.getTime())) {
        return d;
      }
      // Safari-friendly replacement
      d = new Date(s.replace(/-/g, '/'));
      if (!isNaN(d.getTime())) {
        return d;
      }
      // MM/dd/yyyy
      const mmdd = s.match(/^(\d{1,2})[\/](\d{1,2})[\/](\d{2,4})$/);
      if (mmdd) {
        const m = parseInt(mmdd[1], 10) - 1;
        const dnum = parseInt(mmdd[2], 10);
        const y = parseInt(mmdd[3], 10);
        const yy = y < 100 ? 2000 + y : y;
        const dt = new Date(yy, m, dnum);
        if (!isNaN(dt.getTime())) {
          return dt;
        }
      }
      return null;
    };

    const from = normalizeToDate(qp.fromDate);
    const to = normalizeToDate(qp.toDate);
    if (from) {
      this.vm.request.fromDate = from;
    }
    if (to) {
      this.vm.request.toDate = to;
    }

    // When query params provide dates, force specific-date mode so fields display values
    if (from || to) {
      this.vm.showSpecificDates = true;
    }
  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    // console.log(JSON.stringify(ret.fromDateSelect) + '--' + JSON.stringify(ret.toDateSelect));
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;

    // console.log('this.vm.monthCount: ' + this.vm.monthCount);
    // console.log('this.vm.fromDateSelect: ' + JSON.stringify(this.vm.fromDateSelect));
    // console.log('this.vm.toDateSelect: ' + JSON.stringify(this.vm.toDateSelect));
  }

  async FilterOptionsInit() {
    this.urlParams = this.route.snapshot.queryParams;

    const filterRequests = {
      company: this.getFilterValuesWithoutPaging('company', '?state=active'),
      currency: this.getFilterValuesWithoutPaging('currency', '?state=active'),
      location: this.getFilterValuesWithoutPaging('location', '?state=active'),
      accountType: this.getFilterValuesWithoutPaging('account_type', '?state=active'),
      locationGroup: this.getFilterValuesWithoutPaging('location_group', '?state=active'),
      margin: this.getFilterValuesWithoutPaging('account_margin', '?state=active'),
      account: this.getFilterValuesWithoutPaging('account', '?state=active'),
      accountParents: this.getFilterValuesWithoutPaging('account_subtotal', '?state=active'),
      accountSubtotal: this.getFilterValuesWithoutPaging('account_subtotal_no_parents', '?state=active'),
      bank: this.getFilterValuesWithoutPaging('bank', '?state=active'),
      entity: this.getFilterValuesWithoutPaging('entity', '?state=active'),
      entityAddress: this.getFilterValuesWithoutPaging('entity_address', '?state=active'),
      entityType: this.getFilterValuesWithoutPaging('entity_type', '?state=active'),
      paymentType: this.getFilterValuesWithoutPaging('payment_type', '?state=active'),
      inventoryItem: this.getFilterValuesWithoutPaging('item', '?state=active'),
      rfType: this.getFilterValuesWithoutPaging('reporting_field_type', '?state=active'),
      reportingFields: this.getFilterValuesWithoutPaging('reporting_field', '?state=active'),
    };

    try {
      // Await all requests in parallel
      const filterResults = await Promise.allSettled(Object.values(filterRequests));

      // Process the results
      let hasCriticalError = false;

      filterResults.forEach((result, index) => {
        const key = Object.keys(filterRequests)[index]; // Map the key back using index
        if (result.status === 'fulfilled' && Array.isArray(result.value)) {
          this.vm[key] = result.value;
        } else {
          console.error(`Failed to load data for ${key}:`, result || 'Invalid data type');
          // Flag if critical error occurs for any lookup
          hasCriticalError = key === 'criticalKeyHere'; // Example: replace with real critical fields
          // Optionally display a toast for the failure (use ngx-toastr or similar library)
          this.notification.showErrorToast(`Could not load data for ${key}. Please reload the page.`, 'Data Load Error');
        }
      });

      // Optional: Stop further execution if any critical key failed
      if (hasCriticalError) {
        console.error('Critical data load error. Cannot proceed further.');
        // Optionally display a toast to stop the UI
        this.notification.showErrorToast('Critical data loading failed. Please try again later.', 'Critical Error');
        return;
      }

      // Derive rf1-rf5 from reporting_field_type linkage
      const allReportingFields = Array.isArray(this.vm.reportingFields) ? this.vm.reportingFields : [];
      const allReportingFieldTypes = Array.isArray(this.vm.rfType) ? this.vm.rfType : [];

      // Helper to find a type record by code/name/id (supports legacy 'rf1'..'rf5' codes)
      const findType = (key: string) => {
        const lower = String(key).toLowerCase();
        return (
          allReportingFieldTypes.find((v: any) => String(v?.code).toLowerCase() === lower)
          || allReportingFieldTypes.find((v: any) => String(v?.name).toLowerCase() === lower)
          || allReportingFieldTypes.find((v: any) => String(v?.id).toLowerCase() === lower)
        );
      };

      const rf1Type = findType('rf1');
      const rf2Type = findType('rf2');
      const rf3Type = findType('rf3');
      const rf4Type = findType('rf4');
      const rf5Type = findType('rf5');

      const matchTypeId = (val: any) => (x: any) => String(x?.type_id) === String(val?.id);

      this.vm.rf1 = rf1Type ? allReportingFields.filter(matchTypeId(rf1Type)) : [];
      this.vm.rf2 = rf2Type ? allReportingFields.filter(matchTypeId(rf2Type)) : [];
      this.vm.rf3 = rf3Type ? allReportingFields.filter(matchTypeId(rf3Type)) : [];
      this.vm.rf4 = rf4Type ? allReportingFields.filter(matchTypeId(rf4Type)) : [];
      this.vm.rf5 = rf5Type ? allReportingFields.filter(matchTypeId(rf5Type)) : [];

      // Ensure arrays exist to keep downstream logic safe
      this.vm.rf1 = Array.isArray(this.vm.rf1) ? this.vm.rf1 : [];
      this.vm.rf2 = Array.isArray(this.vm.rf2) ? this.vm.rf2 : [];
      this.vm.rf3 = Array.isArray(this.vm.rf3) ? this.vm.rf3 : [];
      this.vm.rf4 = Array.isArray(this.vm.rf4) ? this.vm.rf4 : [];
      this.vm.rf5 = Array.isArray(this.vm.rf5) ? this.vm.rf5 : [];

      // Build a generic map of reporting fields by type id so dropdowns can bind by type dynamically
      const grouped: Record<string, any[]> = {};
      for (const f of allReportingFields) {
        const key = String(f?.type_id ?? '');
        if (!key) {
          continue;
        }
        if (!grouped[key]) {
          grouped[key] = [];
        }
        grouped[key].push(f);
      }
      this.vm.rfByTypeId = grouped;

      // Derive ordered and filtered list of reporting_field_type (rf1..rf5 order),
      // including only types that have linked reporting_field values
      try {
        const types: any[] = Array.isArray(this.vm.rfType) ? [...this.vm.rfType] : [];
        const hasValues = (t: any) => {
          const key = String(t?.id ?? '');
          const arr = grouped[key];
          return Array.isArray(arr) && arr.length > 0;
        };
        const rfIndex = (t: any) => {
          const code = String(t?.code ?? '').toLowerCase();
          const m = code.match(/^rf(\d+)$/);
          return m && m[1] ? Number(m[1]) : Number.MAX_SAFE_INTEGER;
        };
        const byName = (a: any, b: any) => String(a?.name ?? '').localeCompare(String(b?.name ?? ''), undefined, {sensitivity: 'base'});
        const filtered = types.filter(hasValues);
        filtered.sort((a, b) => {
          const ai = rfIndex(a);
          const bi = rfIndex(b);
          if (ai !== bi) {
            return ai - bi;
          }
          return byName(a, b);
        });
        this.vm.rfTypeOrdered = filtered;
        // Ensure templates that iterate on vm.rfType (without checking order) receive rf1..rf5 order
        if (Array.isArray(filtered) && filtered.length) {
          this.vm.rfType = filtered;
        }
      } catch {
      }

      // Process `account` mapping
      if (Array.isArray(this.vm.account)) {
        this.vm.accountName = this.vm.account.map((account) => ({
          name: `${account.number} ${account.name}`,
        }));

        if (this.urlParams.accountId) {
          const matchedAccount = this.vm.account.find(
            (acc) => acc.id === this.urlParams.accountId
          );
          if (matchedAccount) {
            this.vm.accountInput = `${matchedAccount.number} ${matchedAccount.name}`;
            this.vm.request.account_id = matchedAccount.id;
          }
        }
      } else {
        throw new Error('`account` data is invalid or missing.');
      }

      // Process `entityAddress` mappings
      if (Array.isArray(this.vm.entityAddress)) {
        this.vm.entityCity = [];
        this.vm.entityState = [];
        this.vm.entityAddress.forEach((address) => {
          if (
            !this.FilterObject(this.vm.entityCity, {name: address.city}, true)[0] &&
            address.city
          ) {
            this.vm.entityCity.push({name: address.city, id: address.id});
          }
          if (
            !this.FilterObject(this.vm.entityState, {name: address.state}, true)[0] &&
            address.state
          ) {
            this.vm.entityState.push({name: address.state, id: address.id});
          }
        });
      } else {
        throw new Error('`entityAddress` data is invalid or missing.');
      }

      // Handle other mappings like this where needed...

    } catch (error) {
      console.error('An unexpected error occurred while initializing filters:', error);
      // Optionally display a toast here
      this.notification.showErrorToast('Something went wrong while initializing filters. Please try again.', 'Unexpected Error');
    } finally {
      this.isLoading = false;
    }

    // Ensure other actions (if data is present):
    if (
      this.vm.request.toDate &&
      this.vm.request.fromDate &&
      (this.urlParams.accountId ||
        this.urlParams.accountParentId ||
        this.urlParams.accountSubtotalId ||
        this.urlParams.accountTypeId ||
        this.urlParams.bankId ||
        this.urlParams.companyId ||
        this.urlParams.currencyId ||
        this.urlParams.dataType === 'budget' ||
        this.urlParams.entityId ||
        this.urlParams.entityTypeId ||
        this.urlParams.entityState ||
        this.urlParams.entityCity ||
        this.urlParams.locationId ||
        this.urlParams.locationGroupId ||
        this.urlParams.paymentTypeId ||
        this.urlParams.rfId1 ||
        this.urlParams.rfId2 ||
        this.urlParams.rfId3 ||
        this.urlParams.rfId4 ||
        this.urlParams.rfId5 ||
        this.urlParams.marginId)
    ) {
      this.update();
    }
  }


  getFromToDates() {
    if (this.urlParams.fromDate) {
      this.vm.request.fromDate = this.urlParams.fromDate;
    } else {
      let d = new Date();
      d = new Date(d.getFullYear(), d.getMonth() - 1, 1);
      d.setDate(d.getDate());
      this.vm.request.fromDate = new DatePipe('en-US').transform(d, 'MM/dd/yyyy');
    }

    if (this.urlParams.toDate) {
      this.vm.request.toDate = this.urlParams.toDate;
    } else {
      let d = new Date();
      d = new Date(d.getFullYear(), d.getMonth() + 1, 0);
      d.setDate(d.getDate());
      this.vm.request.toDate = new DatePipe('en-US').transform(d, 'MM/dd/yyyy');
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  update() {
    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);
    let errorDescription = '';
    this.vm.fromDateError = this.vm.toDateError = this.vm.dateError = false;
    this.vm.accountTypeName = this.vm.accountParentName = this.vm.accountSubtotalName = '';
    if (!this.vm.request.toDate) {
      errorDescription += $localize`:To Date is required. @@toDateisrequired:To Date is required.` + '\n';
      this.vm.toDateError = true;
    }
    if (!this.vm.request.fromDate) {
      errorDescription += $localize`:From Date is required. @@fromDateisrequired:From Date is required.` + '\n';
      this.vm.fromDateError = true;
    }
    if (tempToDate - tempFromDate < 0) {
      this.vm.dateError = true;
      errorDescription +=
        $localize`:The To Date must be greater than the From Date. @@theToDatemustbegreaterthantheFromDate:The To Date must be greater than the From Date.` +
        '\n';
    }
    if (errorDescription) {
      const arr = errorDescription.split('\n');
      arr.forEach((item) => {
        if (item) {
          this.notification.showWarningToast(item);
        }
      });
    } else {
      // this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      // this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
      this.vm.filtered = false;
      this.vm.monthCount = (tempToDate - tempFromDate) / 86400 / 30 / 1000;
      // this.vm.buttonsDisabled = true;
      const urlParamsJson = {
        // fromDate: this.datePipe.transform(new Date(this.vm.request.fromDate), 'yyyy-MM-dd').toString(),
        // toDate: this.datePipe.transform(new Date(this.vm.request.toDate), 'yyyy-MM-dd').toString(),
        fromDate: this.dateFilter.GetDateFormat(this.vm.request.fromDate),
        toDate: this.dateFilter.GetDateFormat(this.vm.request.toDate),
        account_id: this.vm.request.account_id,
        account_parent_id: this.vm.request.account_parent_id,
        account_subtotal_id: this.vm.request.account_subtotal_id,
        account_type_id: this.vm.request.account_type_id,
        bank_id: this.vm.request.bank_id,
        company_id: this.vm.request.company_id,
        entity_id: this.vm.request.entity_id,
        entity_city: this.vm.request.entity_city,
        entity_state: this.vm.request.entity_state,
        entity_type_id: this.vm.request.entity_type_id,
        item_id: this.vm.request.item_id,
        location_id: this.vm.request.location_id,
        location_group_id: this.vm.request.location_group_id,
        payment_type_id: this.vm.request.payment_type_id,
        rf_id_1: this.vm.request.rf_id_1,
        rf_id_2: this.vm.request.rf_id_2,
        rf_id_3: this.vm.request.rf_id_3,
        rf_id_4: this.vm.request.rf_id_4,
        rf_id_5: this.vm.request.rf_id_5,
        dataType: this.vm.request.dataType,
        margin_id: this.vm.request.margin_id,
      };

      const urlParams: string = this.encodeQueryData(urlParamsJson);
      this.isLoading = true;
      this.tableDataService.getData('transaction_detail', '?' + urlParams).pipe(takeUntil(this.unsubscribeDestroy$))
        .subscribe((result) => {
          this.vm.report = null;
          this.vm.report = result;
          this.buildFlatRows();
          this.isLoading = false;
          if (!this.vm.report.length) {
            this.noDataFound = true;
          } else {
            this.noDataFound = false;
          }
          this.vm.showFilters = this.vm.buttonsDisabled = false;

          this.vm.filtered = this.isFiltered.isFiltered(this.vm);

          if (this.vm.request.dataType) {
            this.vm.dataType = this.vm.request.dataType;
          } else {
            this.vm.dataType = '';
          }

          if (this.vm.request.account_type_id) {
            this.vm.accountTypeName = this.FilterObject(this.vm.accountType, {
              id: this.vm.request.account_type_id,
            })[0].name;
          } else if (this.vm.request.account_parent_id) {
            this.vm.accountParentName = this.FilterObject(this.vm.accountParents, {
              id: this.vm.request.account_parent_id,
            })[0].name;
          } else if (this.vm.request.account_subtotal_id) {
            this.vm.accountSubtotalName = this.FilterObject(this.vm.accountSubtotal, {
              id: this.vm.request.account_subtotal_id,
            })[0].name;
          }

          if (this.vm.request.bank_id) {
            this.vm.bankName = this.FilterObject(this.vm.bank, {id: this.vm.request.bank_id})[0].name;
          } else {
            this.vm.bankName = '';
          }

          if (this.vm.request.company_id) {
            this.vm.companyName = this.FilterObject(this.vm.company, {id: this.vm.request.company_id})[0].name;
          } else {
            this.vm.companyName = '';
          }

          if (this.vm.request.location_id) {
            this.vm.locationName = this.FilterObject(this.vm.location, {id: this.vm.request.location_id})[0].name;
          } else {
            this.vm.locationName = '';
          }

          if (this.vm.request.location_group_id) {
            this.vm.locationGroupName = this.FilterObject(this.vm.locationGroup, {id: this.vm.request.location_group_id})[0].name;
          } else {
            this.vm.locationGroupName = '';
          }

          if (this.vm.request.payment_type_id) {
            this.vm.paymentTypeName = this.FilterObject(this.vm.paymentType, {
              id: this.vm.request.payment_type_id,
            })[0].name;
          } else {
            this.vm.paymentTypeName = '';
          }

          if (this.vm.request.rf_id_1) {
            this.vm.rf1Name = this.FilterObject(this.vm.rf1, {id: this.vm.request.rf_id_1}, true)[0].name;
          } else {
            this.vm.rf1Name = '';
          }

          if (this.vm.request.rf_id_2) {
            this.vm.rf2Name = this.FilterObject(this.vm.rf2, {id: this.vm.request.rf_id_2}, true)[0].name;
          } else {
            this.vm.rf2Name = '';
          }

          if (this.vm.request.rf_id_3) {
            this.vm.rf3Name = this.FilterObject(this.vm.rf3, {id: this.vm.request.rf_id_3}, true)[0].name;
          } else {
            this.vm.rf3Name = '';
          }

          if (this.vm.request.rf_id_4) {
            this.vm.rf4Name = this.FilterObject(this.vm.rf4, {id: this.vm.request.rf_id_4}, true)[0].name;
          } else {
            this.vm.rf4Name = '';
          }

          if (this.vm.request.rf_id_5) {
            this.vm.rf5Name = this.FilterObject(this.vm.rf5, {id: this.vm.request.rf_id_5}, true)[0].name;
          } else {
            this.vm.rf5Name = '';
          }

        });
    }
  }

  async getFilterValuesWithoutPaging(tablename, param) {
    const url = tablename + param + '&pageNumber=0&pageSize=999999';

    try {
      const result: ResponseModel = await firstValueFrom(
        this.tableDataService.getData(url)
      );
      return result.Data;
    } catch (error) {
      console.error(`Error fetching filter values for table: ${tablename}`, error);
      throw error; // Re-throw the error to handle it at a higher level if necessary
    }
  }


  selectAccount(accountId) {
    for (const [y, value] of Object.entries(this.vm.account)) {
      if (this.vm.account[y].id == accountId) {
        this.vm.request.account_id = this.vm.account[y].id;
        this.vm.accountInput = this.vm.account[y].number + ' ' + this.vm.account[y].name;
        this.vm.report = [];
        break;
      }
    }
  }

  testAccount() {
    let accountIdStart: any = '';
    if (this.vm.request.account_id !== undefined) {
      accountIdStart = this.vm.request.account_id;
    } else {
      accountIdStart = '';
    }
    if (!this.vm.accountInput || this.vm.accountInput == '' || this.vm.accountInput == null) {
      this.vm.request.account_id = '';
    } else {
      if (this.FilterObject(this.vm.account, {number_name: this.vm.accountInput}, true).length > 0) {
        this.vm.request.account_id = this.FilterObject(
          this.vm.account,
          {number_name: this.vm.accountInput},
          true
        )[0].id;
      } else {
        this.vm.request.account_id = '';
        this.vm.accountInput = '';
      }
    }
    if (accountIdStart != this.vm.request.account_id) {
      this.vm.report = [];
    }
  }

  updateAccount() {
    // this.vm.buttonsDisabled = true;
    this.vm.startAccount = 0;

    this.tableDataService
      .getData('account', '?state=active&pageNumber=0&pageSize=999999').pipe(takeUntil(this.unsubscribeDestroy$))
      .subscribe((result: ResponseModel) => {
        const data: any = result.Data;
        this.vm.account = data;
        this.vm.buttonsDisabled = false;
      });
  }

  updateEntity() {
    // this.vm.buttonsDisabled = true;
    this.vm.entityCity = this.vm.entityState = [];
    this.tableDataService.getData('entity', '?state=active').pipe(takeUntil(this.unsubscribeDestroy$)).subscribe((result) => {
      this.vm.entity = result;
    });
    this.tableDataService.getData('entity_type', '?state=active').pipe(takeUntil(this.unsubscribeDestroy$)).subscribe((result) => {
      this.vm.entityType = result;
    });
    this.tableDataService.getData('entity_address', '?state=active').pipe(takeUntil(this.unsubscribeDestroy$)).subscribe((result) => {
      this.vm.entityAddress = result;

      this.vm.buttonsDisabled = false;

      for (const [x, value] of Object.entries(this.vm.entityAddress)) {
        if (
          this.FilterObject(this.vm.entityCity, {name: this.vm.entityAddress[x].city}, true)[0] !== undefined &&
          this.vm.entityAddress[x].city
        ) {
          this.vm.entityCity.push({
            name: this.vm.entityAddress[x].city,
          });
        }
      }
      for (const [x, value] of Object.entries(this.vm.entityAddress)) {
        if (
          this.FilterObject(this.vm.entityState, {name: this.vm.entityAddress[x].state})[0] !== undefined &&
          this.vm.entityAddress[x].state
        ) {
          this.vm.entityState.push({
            name: this.vm.entityAddress[x].state,
          });
        }
      }
    });
  }

  selectEntityModal(entityName) {
    this.vm.request.entity_id = '';
    if (this.vm.request.entity_id == '' || 1 === 1) {
      for (const [y, value] of Object.entries(this.vm.entity)) {
        if (this.vm.entity[y].name == entityName) {
          this.vm.entityInput = entityName;
          this.vm.request.entity_id = this.vm.entity[y].id;
          this.vm.report = [];
          break;
        }
      }
    }
  }

  testEntity() {
    const entityIdStart = this.vm.request.entity_id;
    if (!this.vm.entityInput || this.vm.entityInput == '' || this.vm.entityInput == null) {
      this.vm.request.entity_id = '';
    } else {
      if (this.FilterObject(this.vm.entity, {name: this.vm.entityInput}).length > 0) {
        const entityId = this.FilterObject(this.vm.entity, {name: this.vm.entityInput}, true)[0].id;
        const entityName = this.FilterObject(this.vm.entity, {name: this.vm.entityInput}, true)[0].name;
        if (entityId != '' || entityId != null) {
          this.vm.request.entity_id = entityId;
          this.vm.entityInput = entityName;
        } else {
          this.vm.request.entity_id = '';
        }
      } else {
        this.vm.request.entity_id = '';
      }
    }
    if (entityIdStart != this.vm.request.entity_id) {
      this.vm.report = [];
    }
  }

  updateInventoryItem() {
    this.vm.inventoryItemName = [];

    this.tableDataService
      .getData('item', '?state=active&pageNumber=0&pageSize=999999').pipe(takeUntil(this.unsubscribeDestroy$))
      .subscribe((result: ResponseModel) => {
        this.vm.inventoryItem = result.Data;
        for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
          this.vm.inventoryItemName.push({name: this.vm.inventoryItem[x].search_string});
        }
      });
  }

  selectItemModal(itemId) {
    this.vm.request.item_id = itemId;
    for (const [x, value] of Object.entries(this.vm.inventoryItem)) {
      if (this.vm.inventoryItem[x].id == itemId) {
        this.vm.inventoryItemInput = this.vm.inventoryItem[x].code + ' ' + this.vm.inventoryItem[x].name;
        break;
      }
    }
  }

  testItem() {
    const itemIdStart = this.vm.request.item_id;
    if (!this.vm.inventoryItemInput || this.vm.inventoryItemInput == '' || this.vm.inventoryItemInput == null) {
      this.vm.request.item_id = '';
    } else {
      if (this.FilterObject(this.vm.inventoryItem, {search_string: this.vm.inventoryItemInput}, true).length > 0) {
        this.vm.request.item_id = this.FilterObject(
          this.vm.inventoryItem,
          {search_string: this.vm.inventoryItemInput},
          true
        )[0].id;
      } else {
        this.vm.request.item_id = '';
        this.vm.inventoryItemInput = '';
      }
    }
    if (itemIdStart != this.vm.request.item_id) {
      this.vm.report = [];
    }
  }

  close() {
    if (this.routedFrom) {
      this.router.navigateByUrl(this.routedFrom).then();
    } else if (this.routedFrom === '' || this.routedFrom === undefined) {
      window.close();
    } else {
      // should not ever get here
      this.router.navigateByUrl('/home').then();
    }
  }

  clear() {
    this.vm.accountInput = this.vm.entityInput = this.vm.inventoryItemInput = '';
    this.vm.report = [];
    this.vm.request = {
      toDate: null,
      fromDate: null,
      location_group_id: null,
      columns: '',
      company_id: null,
      rf_id_1: null,
      rf_id_2: null,
      rf_id_3: null,
      rf_id_4: null,
      rf_id_5: null,
      margin_id: null,
      location_id: null,
      accountInput: null,
      accountParentId: null,
      accountSubtotalId: null,
      accountTypeId: null,
      dataType: null,
      account_id: null,
      account_parent_id: null,
      account_subtotal_id: null,
      account_type_id: null,
      bank_id: null,
      entity_id: null,
      entity_city: null,
      entity_state: null,
      entity_type_id: null,
      item_id: null,
      payment_type_id: null,
      currency_id: null,
      includeUnposted: null,
    };
    this.vm.filtered = false;
  }

  ngOnDestroy(): void {
    this.unsubscribeDestroy$.next();
    this.unsubscribeDestroy$.complete();
  }

  FilterObject(value, filterObj, actual = false) {
    return this.cFilter.transform(value, filterObj, actual);
  }
}
